<template>
  <div>
    <div class="max-w-5xl mx-auto">
      <div class="px-3 xl:px-0 py-16 md:py-20">
        <h2 class="text-blue-600 text-center text-3xl xl:text-4xl mb-5" v-text="sectionTitle"></h2>
        <div class="flex items-center">
          <div class="flex md:grid grid-cols-4 gap-5 md:gap-5 overflow-x-scroll w-11/12 md:w-full py-5">
            <button
                v-for='(tab, index) in tabs'
                :key='tab.title'
                @click='selectTab(index)'
                class="md:rounded md:shadow md:p-3 flex items-center md:block gap-2 flex-shrink-0 flex-row-reverse"
                :class="tab.isActive ? 'md:bg-blue-500 border-0' : 'md:bg-gray-400 md:border border-blue-300'"
            >
              <div
                  class="w-4 h-4 md:w-6 md:h-6 flex-shrink-0 rounded-full flex items-center justify-center ml-auto"
                  :class="tab.isActive ? 'bg-blue-600 md:bg-white' : 'bg-blue-600'"
              >
                <span
                    class="text-sm md:text-base text-white font-semibold"
                    :class="tab.isActive ? 'text-white md:text-blue-600' : 'text-white'"
                    v-text="tab.locationAmount"
                ></span>
              </div>
              <div
                  class="hidden mb-5 h-16 lg:h-32 mx-auto md:flex justify-center"
                  :class="tab.isActive ? 'text-white' : 'text-blue-600'"
                  v-html="tab.icon"
              ></div>
              <h3
                  class="text-sm md:text-xl md:font-semibold capitalize"
                  :class="tab.isActive ? 'text-blue-600 md:text-white' : 'text-gray-500 md:text-blue-600'"
                  v-text="tab.title"
              ></h3>
            </button>
          </div>
          <div class="w-1/12 md:hidden">
            <svg
                class="m-auto w-5 h-5 stroke-current text-blue-500 feather feather-arrow-right-circle"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1"
                stroke-linecap="round"
                stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 16 16 12 12 8"></polyline>
              <line x1="8" y1="12" x2="16" y2="12"></line>
            </svg>
          </div>
        </div>

        <div ref="locations_slot">
          <slot></slot>
        </div>
      </div>
    </div>

    <div v-if="withMaps" class="relative">
      <div class="absolute inset-x-0 bottom-0 h-1/2"></div>
      <div class="w-full mx-auto">
        <div class="relative sm:overflow-hidden">
          <div class="absolute inset-0">
            <GmapMap
                :center="mapCenter"
                :zoom="mapZoom"
                map-type-id="terrain"
                class="h-full w-full object-cover"
                :options="mapOptions"
            >
              <GmapMarker
                  :key="index"
                  v-for="(m, index) in mapMarkers"
                  :position="m.position"
                  :clickable="true"
                  @click="mapMarkerClick($event, index)"
              >
                <GmapInfoWindow
                    :opened="m.infoWindowOpen"
                    @closeclick="closeInfoWindow(index)"
                >
                  <span class="block text-blue-400 font-semibold capitalize">{{ m.location }}</span>
                  <div class="text-blue-600 text-lg md:text-xl mb-2 group-hover:text-white">{{ m.title }}</div>
                  <a :href="m.googleMapsUrl"
                       :title="m.title"
                       target="_blank" class="flex justify-beteen mt-3 space-x-3 items-center">
                    <span class="text-blue-600 group-hover:text-white">Bekijk op maps</span>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox=" 0 0 24 24"
                        fill="none"
                        stroke-width="1"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="w-5 h-5 stroke-current text-blue-600 group-hover:text-white"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 16 16 12 12 8"></polyline>
                      <line x1="8" y1="12" x2="16" y2="12"></line>
                    </svg>
                  </a>
                </GmapInfoWindow>
              </GmapMarker>
            </GmapMap>
          </div>
          <div class="h-72 md:h-96">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LocationTabs",
  props: {
    sectionTitle: String,
    withMaps: {
      type: Boolean,
      required: false,
      default: false
    },
    locations: {
      type: Array,
      required: false,
      default: []
    },
    infoWindowButtonText: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      selectedIndex: 1,
      tabs: [],
      mapCenter: {
        lat: 52.25,
        lng: 4.7
      },
      mapZoom: 9,
      mapMarkers: [],
      mapOptions: {
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false
      },
      showInformationBox: false
    };
  },
  mounted() {
    this.tabs = Array.from(this.$refs.locations_slot.children).map((child) => child.__vue__);

    this.tabs[0].isActive = true;
    if (this.withMaps) {
      this.mapMarkers = this.locations.map((location) => {
        return {
          title: location.title,
          location_slug: location.location_taxonomy.slug,
          position: {
            lat: location.map_latitude,
            lng: location.map_longitude
          },
          infoWindowOpen: false,
          googleMapsUrl: location.google_maps_url,
          location: location.location_taxonomy.title,
        };
      });
    }
  },
  methods: {
    selectTab(i) {
      this.selectedIndex = i;
      this.setMapFocus(this.tabs[i].mapData);

      this.tabs.forEach((tab, index) => {
        tab.isActive = (index === i);
      });
    },
    setMapFocus(mapData) {
      if (!mapData) {
        return;
      }

      this.mapCenter.lat = mapData.lat;
      this.mapCenter.lng = mapData.lng;
      this.mapZoom       = mapData.zoom;
    },
    mapMarkerClick($event, markerIndex) {
      // Close all other info windows
      this.mapMarkers.forEach((marker, index) => {
        if (index !== markerIndex) {
          marker.infoWindowOpen = false;
        }
      });

      // Toggle the clicked marker's info window
      this.mapMarkers[markerIndex].infoWindowOpen = !this.mapMarkers[markerIndex].infoWindowOpen;

      const mapMarker = this.mapMarkers[markerIndex];

      let tabIndex = this.tabs.findIndex((tab) => {
        return tab.locationSlug === mapMarker.location_slug;
      });

      this.selectTab(tabIndex !== -1 ? tabIndex : 0);
    },
    closeInfoWindow(index) {
      this.mapMarkers[index].infoWindowOpen = false;
    }
  }
};
</script>